import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OpenWithIcon(props: IconProps) {
    return <Icon {...props} iconKey={"open_with"}/>
}
